export function replaceAll(string: string, search: string, replace: string) {
  return string.split(search).join(replace);
}

export const parseStringify = (val:any) => {
  return JSON.parse(JSON.stringify(val))
}